import peopleService from '../api/people'

const state = {
    selectedPeople: null,
    classifiedList: [],
    peoples: [],
    pagination: {
        current_page: 1, total: 1, per_page: 25
    }
}

const getters = {
    selectedPeoplePortrait: (state, getters, rootState) => {
        const people = state.selectedPeople

        if (!people) {
            return null
        }

        if (people.cropped_portrait) {

            const url = '/storage/' + people.cropped_portrait
            const thumbnails = {small: url, large: url, full: url}

            // attach media data if available
            if (people.portrait) {
                const media = people.portrait
                thumbnails.title = media.title
                thumbnails.description = media.description
                thumbnails.credits = media.credits
            }

            return thumbnails
        }

        if (people.portrait) {
            const portraitMediaImages = rootState.media.mediasImages[people.portrait.id]

            if (portraitMediaImages) {
                return Object.values(portraitMediaImages)[0]
            }
        }

        return null
    }
}

const actions = {
    getPeople({commit, state, dispatch}, peopleId) {
        const requestId = 'GET_PEOPLE_' + peopleId
        commit('title/resetTitle', '', {root: true})
        commit('setSelectedPeople', null)
        commit('ui/enableLoader', requestId, {root: true})

        return peopleService.find(peopleId ? peopleId : state.selectedPeople.id).then(response => {
            const people = response.data
            commit('setSelectedPeople', people)
            commit('title/updateTitle', people.name, {root: true})

            if (people.portrait) {
                dispatch('media/getMediaImages', people.portrait.id, {root: true})
            }

            for (const event of people.events.filter(e => e.cover && e.cover.file)) {
                // load asynchronously the linked events covers
                dispatch('file/getFileThumbnails', event.cover.file.id, {root: true})
            }

            return people
        }, () => false).finally(() => commit('ui/disableLoader', requestId, {root: true}))
    },

    search({commit, state}, {query, page = null, paginationSize = null}) {
        const requestId = 'SEARCH_PEOPLE'

        return peopleService.search(query, page, paginationSize).then(response => {
            const result = response.data
            const peoples = result.data ? result.data : result
            const pagination = result.current_page
                ? {current_page: result.current_page, total: result.total, per_page: result.per_page}
                : {current_page: 1, total: peoples.length, per_page: peoples.length}

            commit('setPeoples', peoples)
            commit('setPagination', pagination)

            return peoples
        }, () => false)
    }
}

const mutations = {
    setSelectedPeople(state, people) {
        state.selectedPeople = people
    },
    setPeoples(state, peoples) {
        state.peoples = peoples.sort(function (a, b) {
            return a.compare.toLowerCase().localeCompare(b.compare.toLowerCase(), 'fr', { sensitivity: 'base'})
        })
    },
    setPagination(state, pagination) {
        state.pagination = pagination
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
